import { KameleonBase } from "./kameleon-base";
import { themeColor } from "./theme-helper";

export const Gamma: typeof KameleonBase & any = () => ({
  colors: {
    variables: {
      _neutral: "#F7FBF3",
      _mainCTA: "#84B118",
      _secondaryCTA: "#E27700",
      _dark: "#CE1F48",
      _darkest: "#00211A",
      _neutralLight: "#FFFFFF",
    },
  },
  fontSizes: [
    "0.75rem",
    "0.875rem",
    "1rem",
    "1.125rem",
    "1.25rem",
    "1.5rem",
    "1.75rem",
    "2rem",
    "2.25rem",
    "2.5rem",
    "2.75rem",
    "3rem",
    "3.25rem",
    "3.5rem",
    "3.75rem",
    "4rem",
    "4.5rem",
    "5rem",
    "5.25rem",
    "5.5rem",
    "7.5rem",
    "10rem",
  ],
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  text: {
    large: {
      fontSize: [5, null, 6],
    },
    medium: {
      fontSize: [4, null, 5],
    },
    mediumSmall: {
      fontSize: [3, null, 4],
    },
    small: {
      fontSize: 2,
    },
    tiny: {
      fontSize: 1,
    },
    tagline: {
      fontSize: 1,
      textTransform: "uppercase",
      fontWeight: "700",
      letterSpacing: "3px",
    },
  },
  styles: {
    h1: {
      variant: "text.heading",
      fontSize: [18, null, 19, 20],
      lineHeight: 1.2,
    },
    h2: {
      variant: "text.heading",
      fontSize: [14, null, 17, 18],
      lineHeight: 1.2,
    },
    h3: {
      variant: "text.heading",
      fontSize: [11, null, 12, 13],
      lineHeight: 1.2,
    },
    h4: {
      variant: "text.heading",
      fontSize: [8, null, 9, 10],
      lineHeight: 1.3,
    },
    h5: {
      variant: "text.heading",
      fontSize: [5, null, 6],
      lineHeight: 1.4,
    },
    h6: {
      variant: "text.heading",
      fontSize: [4, null, 5],
      lineHeight: 1.4,
    },
    p: {
      fontSize: 2,
    },
    b: {
      fontSize: 2,
      fontWeight: "bold",
    },
  },
  cards: {
    primary: {
      bg: themeColor("cards.primary.bg"),
      boxShadow: `0 4px 28px ${themeColor("variables.grays.10")}`,
      borderRadius: "8px",
    },
    vertical: {
      default: {
        gridColumnGap: "1.5rem",
        gridRowGap: "1rem",
        "@media screen and (max-width: 767px)": {
          gridRowGap: "1.5rem",
          gridTemplateColumns: "1fr",
        },
        "@media screen and (max-width: 479px)": {
          gridRowGap: "1.5rem",
          gridTemplateColumns: "1fr",
          gridTemplateRows: "auto auto",
        },
      },
      content: {
        paddingTop: "2.5rem",
        paddingBottom: "2.5rem",
        paddingRight: "2.5rem",
        "@media screen and (max-width: 767px)": {
          paddingTop: "0",
          paddingBottom: "1.5rem",
          paddingRight: "1.5rem",
          paddingLeft: "1.5rem",
        },
      },
    },
    horizontal: {
      default: {},
      content: {
        paddingLeft: "2.5rem",
        paddingBottom: "2.5rem",
        paddingRight: "2.5rem",
        "@media screen and (max-width: 767px)": {
          paddingBottom: "1.5rem",
          paddingRight: "1.5rem",
          paddingLeft: "1.5rem",
        },
      },
    },
  },
  buttons: {
    primary: {
      color: "buttons.primaryText",
      bg: "primary",
      cursor: "pointer",
      borderRadius: "8px",
      fontSize: 3,
      padding: "1rem 2rem",
      transition: "all .1s ease-in-out",
      "&:focus": {
        bg: themeColor("links.hover"),
      },
      "&:hover": {
        bg: themeColor("buttons.backgroundHover"),
      },
      "&:active": {
        bg: themeColor("buttons.backgroundActive"),
      },
      "&:disabled": {
        bg: themeColor("buttons.disabled"),
        cursor: "not-allowed",
      },
    },
    secondary: {
      color: themeColor("secondary"),
      background: "none",
      cursor: "pointer",
      border: `1px solid ${themeColor("secondary")}`,
      borderRadius: 0,
      fontSize: 3,
      padding: "1rem 2rem",
      transition: "all .1s ease-in-out",
      "&:focus": {
        bg: themeColor("buttons.secondaryBackgroundHover"),
      },
      "&:hover": {
        bg: themeColor("buttons.secondaryBackgroundHover"),
      },
      "&:active": {
        bg: themeColor("buttons.secondaryBackgroundActive"),
      },
    },
  },
  images: {
    nonBackground: {
      borderRadius: "8px",
    },
    card: {
      horizontal: {
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
      },
      vertical: {
        borderTopLeftRadius: "8px",
        borderBottomLeftRadius: "8px",
      },
    },
  },
  boxes: {
    footer: {
      borderRadius: "4px",
    },
    slider: {
      boxShadow: "large",
      borderRadius: "4px",
      slide: {
        backgroundColor: themeColor("muted"),
      },
    },
  },
});
